/**
 * Created by neo on 16.08.23
 */
import { makeAutoObservable } from 'mobx';
import { OnlineMeetingEntryEmbedDataEntry, createOnlineMeetingEntryEmbedDataEntry } from './OnlineMeetingEntryEmbedDataEntry';

export type OnlineMeetingEntryEmbedData = {
  web?: OnlineMeetingEntryEmbedDataEntry;
  app?: OnlineMeetingEntryEmbedDataEntry;
};

export function createOnlineMeetingEntryEmbedData(json?: Partial<OnlineMeetingEntryEmbedData>): OnlineMeetingEntryEmbedData {
  return makeAutoObservable({
    web: json?.web ? createOnlineMeetingEntryEmbedDataEntry(json.web as any) : undefined,
    app: json?.app ? createOnlineMeetingEntryEmbedDataEntry(json.app as any) : undefined,
  });
}
